import React from 'react';
import Modal from 'react-bootstrap/Modal';

const DeleteModal = ({ show, handleClose,modalData ,handleSubmit}) => {

  
    return (

        <div >
            <Modal backdrop="static"
        keyboard={false} show={show} centered onHide={handleClose} className='deleteModal'  >

                <div className="border border-primary border-4">
                    <Modal.Header closeButton className='bg-primary text-white'>
                        <Modal.Title>Confirm Deletion</Modal.Title>
                    </Modal.Header>
                    <Modal.Body > <h4 className='text-center'>Are You Sure You Want To Remove This Item ?</h4>

                    <h6 className='text-center text-info' >{modalData}</h6>


                        <div className="d-flex justify-content-between">

                            <button onClick={handleClose} className='ms-0 btn px-4 close__button'>
                                <p className='mb-0 px-4'>  Cancel</p>
                            </button>
                            <button onClick={handleSubmit} className='px-5 btn-primary'>
                                <p className='mb-0 px-4'>  Ok</p>
                            </button>
                        </div>

                    </Modal.Body>




                </div>

            </Modal>
        </div>

    )
}

export default DeleteModal